export type DeploymentContext =
  | { kind: 'softion' }
  | { kind: 'demo'; sCode: string }
  | { kind: 'demo-link' }
  | { kind: 'tenant'; slug: string; channel: 'active' | 'beta' };

const EXCLUDED_FIRST_SEGMENTS = ['www', 'app', 'api'];

export function classifyHostname(hostname: string): DeploymentContext {
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return { kind: 'tenant', slug: '', channel: 'active' };
  }
  if (hostname === 'softion.io' || hostname === 'www.softion.io') {
    return { kind: 'softion' };
  }

  const parts = hostname.split('.');
  if (parts.length < 3 || EXCLUDED_FIRST_SEGMENTS.includes(parts[0])) {
    return { kind: 'tenant', slug: '', channel: 'active' };
  }

  const segment = parts[0];

  if (segment === 'demo-webly') return { kind: 'demo-link' };

  const demoMatch = segment.match(/^(.+)-demo-webly$/);
  if (demoMatch) return { kind: 'demo', sCode: demoMatch[1] };

  const betaMatch = segment.match(/^(.+)-beta$/);
  if (betaMatch) return { kind: 'tenant', slug: betaMatch[1], channel: 'beta' };

  return { kind: 'tenant', slug: segment, channel: 'active' };
}
